import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <nav className="navbar">
        <div className="logo">Workflow Diagram <span className="highlight">MCP</span></div>
        <div className="nav-links">
          <a href="#how-it-works">How it Works</a>
          <a href="#team">Team</a>
        </div>
      </nav>

      <header className="hero-section">
        <div className="hero-content">
          <div className="badge">New: Powered by Gemini Nano Banana Pro</div>
          <h1>Transform Text into <br /><span className="gradient-text">Workflow Diagrams</span></h1>
          <p className="hero-subtext">
            The Model Context Protocol (MCP) tool that instantly visualizes your architecture. 
            Seamlessly integrated with Claude, Cursor, and Copilot.
          </p>
          
          <div className="video-container">
            <div className="video-wrapper">
              <iframe 
                width="100%" 
                height="100%" 
                src="https://www.youtube.com/embed/0cfyy-0XdJk?si=tftXD3G1lSuT4IkD" 
                title="Workflow Diagram MCP Demo" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
              ></iframe>
            </div>
            <div className="video-glow"></div>
          </div>
        </div>
      </header>

      <section id="how-it-works" className="workflow-section">
        <div className="section-header">
          <h2>How It Works</h2>
          <p>From setup to visualization in three simple steps.</p>
        </div>
        <div className="steps-container">
          <div className="step fade-in-up" style={{animationDelay: '0.2s'}}>
            <div className="step-icon">⚙️</div>
            <h3>Add to Environment</h3>
            <p>Configure the MCP server in your favorite IDE settings.</p>
          </div>
          <div className="connector-line"></div>
          <div className="step fade-in-up" style={{animationDelay: '0.4s'}}>
            <div className="step-icon">💬</div>
            <h3>Ask the Agent</h3>
            <p>Simply ask: "Explain how this code works with a workflow diagram."</p>
          </div>
          <div className="connector-line"></div>
          <div className="step fade-in-up" style={{animationDelay: '0.6s'}}>
            <div className="step-icon">✨</div>
            <h3>Instant Visualization</h3>
            <p>Watch as Gemini generates a professional diagram right in your chat interface.</p>
          </div>
        </div>
      </section>

      <section id="team" className="team-section">
        <h2>Built by Team Fifty-Four</h2>
        <div className="team-grid">
          <a href="https://huggingface.co/jatindx" className="team-member">Jatin Dogra</a>
          <a href="https://huggingface.co/crazydiv" className="team-member">Kartik Godawat</a>
          <a href="https://huggingface.co/priyam307" className="team-member">Priyam Shukla</a>
        </div>
      </section>
    </div>
  );
}

export default App;
